import styled from 'styled-components';

const clsPrefix = 'ui-divider';

export const dividerClasses = {
  component: clsPrefix,
  label: `${clsPrefix}-label`,
  content: `${clsPrefix}-content`,
} as const;

interface IDividerSCProps {
  thickness?: number;
  variant?: 'on-dark' | 'on-light';
}

export const DividerSC = styled.div<IDividerSCProps>`
  display: flex;
  flex-direction: row;
  position: relative;

  &::before,
  &:after {
    position: relative;
    top: 50%;
    flex: 1;
    border-block-start: ${({ thickness }) => thickness}px solid
      ${({ theme, variant }) =>
        variant === 'on-dark' ? theme.color.border.emphasisDark : theme.color.border.emphasis};
    border-block-end: 0;
    transform: translateY(50%);
    content: '';
  }

  .${dividerClasses.content} {
    padding: 0 16px;
  }
`;
